<ion-loading [backdropDismiss]="false" [isOpen]="isShow()" [message]="message()"></ion-loading>
